if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    if(document.querySelector('.tabs-quad__filter')){
        const QUAD = document.querySelector('.tabs-quad');
        let tabs = QUAD.querySelectorAll('.tabs-quad__filter ul li');
        let items = QUAD.querySelectorAll('.tabs-quad__item');
        let lastClick = null;
        tabs.forEach((tab)=> {
            tab.addEventListener('click',(e)=>{
                let tag = e.target.dataset.tag;
                if(lastClick){
                    lastClick.classList.remove('active');
                }
                tab.classList.add('active');
                items.forEach((item)=>{
                    item.classList.toggle('active', item.dataset.tag == tag);
                })
                lastClick = tab;
            })
        })
        tabs[0].click();
    }

    if(document.querySelector('.js-open-booking')){
        document.querySelectorAll('.js-open-booking').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault;
                document.getElementById('booking-widget').classList.add('show');
            })
        })
    }

    document.querySelectorAll('.js-open-menu').forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
            e.preventDefault;
            document.getElementById('menu').classList.add('show');
        });
    })

    document.querySelectorAll('.js-close-menu').forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
            e.preventDefault;
            document.getElementById('menu').classList.remove('show');
        });
    })

    document.querySelectorAll('.js-close-booking').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            document.getElementById('booking-widget').classList.remove('show');
        });
    })

    if(document.getElementsByClassName('js-accordion-title')){        
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    }

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    $('.featured-items__slider').slick({
        arrows: true,
        slidesToShow:3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    // GALLERY-FLEX FULLSCRREN MODE
	if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
	}

    $('.gallery-quad__slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 700,
        fade: true
    });

    const anchors = document.querySelectorAll('.js-scroll');

    anchors.forEach((anchor)=>{
        if(anchor.getAttribute('href').indexOf('#') > -1){
            let element = anchor.getAttribute('href').split('#')[1];
            let headerHeight = document.querySelector('header').offsetHeight;
            let elementHeight = document.getElementById(element).offsetTop;
            anchor.addEventListener('click', (e)=>{
                e.preventDefault();
                window.scrollTo({
                    top: elementHeight - headerHeight,
                    behavior: 'smooth'
                });
            })
        }
    })

})();